<template>
<div class="chapter">
<div class="inner_page">
<p class="partno"><a id="page_13">PART I</a></p><a id="page_13">
<p class="parttitle">The Silent Era: <i>Between Global Capitalism and National Modernization</i></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 11_Part01.vue?42617620